import { CountUp } from 'countup.js';

import '../sass/stat-cards.scss';

(() => {
    const $blocks = document.querySelectorAll('.stat-cards');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $content = $block.querySelector('.stat-cards__content');
        const $cards = $block.querySelectorAll('.stat-cards__card');

        const initCards = () => {
            if (!$cards) return;
                
            $content.addEventListener('onScreen', () => {
                $cards.forEach($card => {
                    const $numbers = $card.querySelectorAll('.stat-cards__card-stat-number');

                    let counters = [];

                    if ($numbers) {
                        $numbers.forEach($number => {
                            const countUp = new CountUp($number);

                            counters.push(countUp);
                        })
                    }

                    counters.forEach(counter => {
                        counter.start();
                    });
                });
            });
        };

        initCards();
    });
})();
